import { Flags, useFeatureFlag } from './useFeatureFlags';
import useLinkAccount, { AccountType } from './useLinkAccount';

/**
 * Custom hook to determine the state of the PUJ feature flag.
 * It also checks if the user is using a guest account.
 *
 * @param {boolean} [exemptGuestUserCheck] - Optional parameter to exempt guest user check.
 *
 * @returns {Object} - isPujEnabled: boolean
 *
 */

const usePujFlag = (exemptGuestUserCheck?: boolean) => {
  const { isOn } = useFeatureFlag(Flags.PACKAGE_UPGRADE_JOURNEY);
  const { isAccountLinked } = useLinkAccount();
  const isNotGuestAccount = isAccountLinked(AccountType.SkyDth);

  const isPUJEnabled = exemptGuestUserCheck ? isOn : isOn && isNotGuestAccount;

  return { isPUJEnabled };
};

export default usePujFlag;
